import React, { useState } from 'react';
import IconButton from '../../components/shared/IconButton';
import UrlInput from '../../components/shared/UrlInput';
import { PlusIcon } from 'lucide-react';
import logo from "../../assets/logos/WhiteLogo.png";
import { apiConnecter } from '../../services/apiConnector';
import { useSelector } from 'react-redux';
import Modal from '../../components/shared/ErrorModal';
import API_ENDPOINTS from '../../constant/EndPoints';

const Settings = () => {
    /* ****************************************************************
    *                            STATES                             *
    ******************************************************************/
    const userInfo = useSelector((state) => state.userInfo);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [fieldErrors, setFieldErrors] = useState({ oldPassword: '', newPassword: '' });


    /* ****************************************************************
    *                            SERVICES                             *
    ******************************************************************/
    /**
  * Handles the process of changing the user's password.
  * @returns {void}
  */

    const handleChangePassword = async () => {
        setMessage('');
        setMessage('');
        setFieldErrors({ oldPassword: '', newPassword: '' });
        if (loading) return
        // Simple validation
        if (!oldPassword) {
            setFieldErrors((prev) => ({ ...prev, oldPassword: 'Old password is required.' }));
        }
        if (!newPassword) {
            setFieldErrors((prev) => ({ ...prev, newPassword: 'New password is required.' }));
        }
        if (!oldPassword || !newPassword) return;
        try {
            setLoading(true);
            const payload = {
                email: userInfo.user.email,
                oldPassword,
                newPassword,
            };

            const response = await apiConnecter("POST", API_ENDPOINTS.REACT_APP_CHANGE_PASSWORD_END_POINT, payload, { Authorization: `Bearer ${userInfo.token}` });
            console.log(response, "response")
            Modal({
                title: "Success",
                message: "Password changed successfully.",
            });
            setOldPassword('');
            setNewPassword('');
            setFieldErrors({ oldPassword: '', newPassword: '' });

        } catch (error) {
            Modal({
                title: "Error",
                message: error?.response?.data?.message || "An error occurred while changing the password.",
            });
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    
    /* ****************************************************************
      *                            HELPER FUNCTION                      *
      ******************************************************************/
    /**
* Determines the CSS class for the input border based on field validation errors.
* 
* @param {string} fieldName - The name of the input field (e.g., 'oldPassword', 'newPassword').
* @returns {string} - The CSS class to apply for the input's border style.
*/
    const getInputBorderClass = (fieldName) => (
        fieldErrors[fieldName] ? "border-orange-600 focus:border-orange-600" : "border-transparent focus:border-[var(--color-primary)]"
    );

    return (
        <div className='w-full m-4 '>
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h2 className="text-2xl font-semibold text-[var(primary-text-color)]">Settings</h2>
                    <p className="text-[var(--secondary-text-color:)] text-sm mt-1">Configure SparkMotion platform settings</p>
                </div>
            </div>
            {/* Inputs for old and new Password */}
            <div className="bg-[var(--color-surface-background)] rounded-2xl border border-[var(--border-color)] p-6">
                <h3 className="text-md font-bold text-[var(primary-text-color)]">Change Password</h3>

                <div className="space-y-4 mt-4">
                    <div>
                        <label htmlFor="oldPassword" className="block text-sm font-semibold text-[var(primary-text-color)]">Old Password</label>
                        <input
                            id="oldPassword"
                            type="password"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            placeholder="Enter Your Password"
                            className={`mt-2 block w-full rounded-md bg-[var(--color-surface-input)] px-3 py-2 text-sm sm:text-base text-[var(--color-text-base)] placeholder-[var(--color-input-placeholder)] outline-none border transition-colors duration-200 ${getInputBorderClass('oldPassword')}`}
                        />
                        {fieldErrors.oldPassword && <p className="mt-1 text-xs text-orange-600">{fieldErrors.oldPassword}</p>}
                    </div>

                    <div>
                        <label htmlFor="newPassword" className="block text-sm font-semibold text-[var(primary-text-color)]">New Password</label>
                        <input
                            id="newPassword"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Enter Your Password"
                            className={`mt-2 block w-full rounded-md bg-[var(--color-surface-input)] px-3 py-2 text-sm sm:text-base text-[var(--color-text-base)] placeholder-[var(--color-input-placeholder)] outline-none border transition-colors duration-200 ${getInputBorderClass('newPassword')}`}
                        />
                        {fieldErrors.newPassword && <p className="mt-1 text-xs text-orange-600">{fieldErrors.newPassword}</p>}
                    </div>

                    {message && <p className="text-sm text-orange-400">{message}</p>}
                    {/* ChangePassword Button */}
                    <IconButton
                        icon={PlusIcon}
                        label={loading ? "Updating..." : "Change Password"}
                        onClick={handleChangePassword}
                        disabled={loading}
                        hoverColor="hover:bg-orange-600"
                        bgColor='bg-[var(--color-primary)]'
                        textColor='text-white'
                    />
                </div>
            </div>


        </div>
    );
};

export default Settings;
